import { ConversationChannel } from 'src/api/generated';
import { TimelineCallItem } from '../molecules/timeline/timeline-call-item';
import { TimelineWhatsAppItem } from '../molecules/timeline/timeline-whatsapp-item';
import { TimelineEmailItem } from '../molecules/timeline/timeline-email-item';
import { TimelineStatusItem } from '../molecules/timeline/timeline-status-item';
import {
  isCallItem,
  isMessageItem,
  isStatusHistoryItem,
} from '../../utils/timeline/item-type-guards.util';
import { useTimelineItemContext } from '../../hooks/timeline/timeline-item-context';

import type { TimelineInteractionItemProps } from '../../types/timeline/compact-timeline.types';

export const TimelineInteractionItem: React.FC<
  TimelineInteractionItemProps
> = ({
  item,
  isContinuation,
  isNew = false,
  contact,
  onPlayRecording,
  activeCallId,
  statuses = [],
  funnelId,
  conversationId,
}) => {
  const itemContext = useTimelineItemContext({
    item,
    currentFunnelId: funnelId,
    currentConversationId: conversationId,
  });

  if (isCallItem(item)) {
    return (
      <TimelineCallItem
        item={item}
        isNew={isNew}
        contact={contact}
        onPlayRecording={onPlayRecording}
        activeCallId={activeCallId}
        context={itemContext}
      />
    );
  }

  if (isMessageItem(item)) {
    const messageItem = item;
    switch (messageItem.channel) {
      case ConversationChannel.WHATSAPP:
      case ConversationChannel.SMS:
        return (
          <TimelineWhatsAppItem
            item={messageItem}
            isContinuation={isContinuation}
            isNew={isNew}
            contact={contact}
            context={itemContext}
          />
        );
      case ConversationChannel.EMAIL:
        return (
          <TimelineEmailItem
            item={messageItem}
            isNew={isNew}
            contact={contact}
            context={itemContext}
          />
        );
    }
  }

  if (isStatusHistoryItem(item)) {
    return <TimelineStatusItem item={item} statuses={statuses} />;
  }

  // Fallback for unknown types
  console.warn('Unknown timeline item encountered in TimelineInteractionItem', {
    item,
  });
  return null;
};
